// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3mffb","swiperWrapper":"Slider_swiperWrapper__3cT2Y","swiperContainer":"Slider_swiperContainer__vhKFj","topPanel":"Slider_topPanel__m4Xhq"};